<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <v-row>
        <v-col cols="4">
          <v-autocomplete
            v-model="selectedComplexId"
            :items="complexes"
            item-value="id"
            item-text="text"
            label="مجموعه"
            :search-input.sync="searchComplex"
            outlined
            dense
            hide-details
            hide-selected
            no-data-text="موردی یافت نشد"
            @change="getSubComplexes"
          ></v-autocomplete>
        </v-col>

        <v-col cols="4">
          <v-autocomplete
            v-model="selectedSubComplexId"
            :items="subComplexes"
            item-value="id"
            item-text="text"
            label="زیر مجموعه"
            :search-input.sync="searchSubComplex"
            outlined
            dense
            hide-details
            hide-selected
            no-data-text="موردی یافت نشد"
            @change="getDevices(selectedSubComplexId)"
          ></v-autocomplete>
        </v-col>
        <v-col cols="4">
          <v-autocomplete
            v-model="support.deviceId"
            :items="users"
            item-value="id"
            item-text="text"
            label="دستگاه"
            :search-input.sync="searchDevice"
            outlined
            dense
            hide-details
            hide-selected
            no-data-text="موردی یافت نشد"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <calenderSelect ref="dateRef" />
      </v-row>

      <v-spacer></v-spacer>
      <br />
      <v-btn :loading="loading" color="blue darken-1" text @click="submit()"
        >دریافت</v-btn
      >
    </v-container>
  </v-form>
</template>

<script>
import Vue from "vue";
import request from "@/utils/request";
import calenderSelect from "@/components/common/CalenderSelect.vue";
import moment from "moment-jalaali";

export default Vue.extend({
  name: "ExcelExport",
  components: { calenderSelect },
  data: () => ({
    isUserEdit: false,
    isComplexEdit: false,
    complexNameInput: "",
    userNameInput: "",
    supportId: null,
    selectedComplex: {},
    selectedUser: {},
    complexes: [],
    subComplexes: [],
    selectedComplexId: null,
    selectedSubComplexId: null,
    searchComplex: null,
    searchSubComplex: null,
    searchDevice: null,
    users: [],
    dialog: false,
    valid: true,
    loading: false,
    imageUrl: "",
    isUnit: false,
    support: {
      from: "",
      to: "",
      deviceId: "",
      complexId: ""
    }
  }),
  watch: {
    dialog: {
      handler() {
        if (!this.dialog) {
          this.support.startTime = null;
          this.support.endTime = null;
          this.support.deviceId = null;
          this.support.complexId = null;
          this.selectedSubComplexId = null;
          this.selectedComplexId = null;

          this.supportId = null;
        }
        if (this.supportId) {
          this.getSupport(this.supportId);
        }
      },
      deep: true
    }
  },

  created() {
    this.getComplexes();
  },

  methods: {
    clearFrom() {
      this.support.from = null;
    },
    clearTo() {
      this.support.to = null;
    },
    complexFilter(item, queryText, itemText) {
      const searchText = queryText.toLowerCase();
    },
    userFilter(item, queryText, itemText) {
      const searchText = queryText.toLowerCase();
    },
    async getComplexes() {
      await request.get(`/publicData/main-complexes`).then(response => {
        var data = response.data.result;
        this.complexes = data;
        this.complexes.unshift({ id: null, text: "انتخاب..." });
      });
    },
    async getSubComplexes() {
      if (this.selectedComplexId) {
        await request
          .get(`/publicData/sub-complexes/${this.selectedComplexId}`)
          .then(response => {
            var data = response.data.result;
            this.subComplexes = data;
            this.subComplexes.unshift({ id: null, text: "انتخاب..." });
            this.getDevices(this.selectedComplexId);
          });
      }
    },
    async getDevices(complexId) {
      if (complexId) {
        await request
          .get(`/publicData/main-complexes-devices/${complexId}`)
          .then(response => {
            var data = response.data.result;
            this.users = data;
            this.users.unshift({ id: null, text: "انتخاب..." });
          });
      }
    },

    submit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (!this.$refs.dateRef.from) {
        alert("لطفا تاریخ شروع را وارد نمایید");
        return;
      }
      if (!this.$refs.dateRef.to) {
        alert("لطفا تاریخ پایان را وارد نمایید");
        return;
      }
      this.support.from = this.$refs.dateRef.from;
      this.support.to = this.$refs.dateRef.to;

      this.support.from = moment(
        this.$refs.dateRef.from,
        "jYYYY/jMM/jDD"
      ).format("YYYY-MM-DD");
      this.support.to = moment(this.$refs.dateRef.to, "jYYYY/jMM/jDD").format(
        "YYYY-MM-DD"
      );

      this.support.selectedComplexId = this.selectedComplexId;
      this.support.selectedSubComplexId = this.selectedSubComplexId;

      const filterQuery = Object.keys(this.support)
        .filter(x => this.support[x] !== null && this.support[x] !== undefined)
        .map(key => `${key}=${this.support[key]}`)
        .join("&");
      this.loading = true;
      request
        .get(`/deviceManagement/excel-log?${filterQuery}`, {
          responseType: "blob"
        })
        .then(response => {
          if (!response.data || response.data.size === 0) {
            alert("دیتایی برای دانلود یافت نشد");
            return;
          }

          const blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });

          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = "report.xlsx";
          document.body.appendChild(a);
          a.click();

          // cleanup
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        })
        .catch(() => {
          alert("خطا در دریافت فایل");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
</script>

<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}

.card-form-img {
  padding: 0px !important;
}

.icon-btn-modal {
  position: absolute;
  font-size: 18px !important;
  color: #fff !important;
  padding: 8px;
  border-radius: 50%;
}

.icon-btn-modal:hover {
  cursor: pointer;
}

.icon-btn-upload {
  position: absolute;
  left: 60%;
  bottom: 33%;
  color: #fff !important;
  /*padding: 8px;*/
  border-radius: 50%;
  /*background: #35495E !important;*/
  text-align: center;
  display: flex;
  margin: auto;
  justify-content: center;
  align-items: center;
  /*height: 20px !important;*/
  /*width: 20px !important;*/
}

.v-icon {
  color: #fff !important;
  font-size: 18px !important;
  text-align: center;
  background: #35495e !important;
}

.logo-title {
  text-align: center;
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}
</style>
